import { httpClient } from '../provider/dataProvider';


export const getSalesOrderById = async id => {
  const res = await httpClient(`/api/SaleOrder/${id}`);
  return res.json;
};